<template>
	<div class="header-box">
		<div class="header">
			<div class="icon-box" style="margin-right: 10px;">
				<img src="../assets/imgs/3.png" @click="chengleft(true)" v-if="!isCollapse" style="width: 20px;height: 20px;"/>
				<img src="../assets/imgs/4.png" @click="chengleft(false)" style="width: 20px;height: 20px;" v-else/>
			</div>
			
			<div class='rig'>
				<div class="icon-box">
					<img src="../assets/imgs/quanping.png" class="navico" @click="screen"/>
				</div>
				<div class="icon-box">
					<img src="../assets/imgs/sx1.png" class="navico" @click="$router.go(0)"/>
				</div>
				<div class="icon-box">
					<el-dropdown @command="handleCommand">
						<span class="el-dropdown-link" style="color: #333;">
							<img src="../assets/imgs/dl.png" class="navico" />
						</span>				
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command='2'>退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>	
		</div>
		
		<el-dialog title="提现" :visible.sync="tixianshow" width="350px">
			<el-form label-width="90px" label-position="left" >
				<el-form-item label="余额: " prop="kddh">
					{{num}}
				</el-form-item>
				<el-form-item label="提现金额: " prop="kdmc">
					<el-input-number v-model="money" size :min="0.01" :precision="2"></el-input-number>
				</el-form-item>
			</el-form>
			<div style="text-align: center;">
				<el-button type="warning" @click="tixian">提现</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import theme from '@/components/theme.vue'
	export default {
		data() {
			return {
				fullscreen: false,
				shop: {}, // 🔥 修复：初始化空对象，不报错
				password: '',
				num:0,
				money:1,
				tixianshow:false
			}
		},
		created() {
			// ==============================================
			// 🔥 总后台安全读取，永不报错 user_name
			// ==============================================
			try {
				this.shop = JSON.parse(sessionStorage.getItem('admin') || '{}')
			} catch (e) {
				this.shop = {}
			}
		},
		computed: {
			isCollapse() {
				return this.$store.state.leftnav.isCollapse
			},
			routeArr() {
				return this.$store.state.routeArr
			},
			thispath: {
				get() {
					return this.$store.state.thispath
				},
				set(value) {}
			},
		},
		methods: {
			chengleft(val) {
				this.$store.commit('chengleft', val)
			},
			screen() {
				let element = document.documentElement;
				if (this.fullscreen) {
					document.exitFullscreen?.();
				} else {
					element.requestFullscreen?.();
				}
				this.fullscreen = !this.fullscreen;
			},
			delpath(path) {
				if (path.indexOf('pinedit') > -1) {
					let id = path.split('?')[1].split('&')[0].split('=')[1]
					setTimeout(() => {
						sessionStorage.removeItem('pinform' + id || 'undefined')
						sessionStorage.removeItem('pinwatchform' + id || 'undefined')
						sessionStorage.removeItem('pinteams' + id || 'undefined')
					}, 200)
				}
				if (path.indexOf('qiangedit') > -1) {
					let id = path.split('?')[1].split('&')[0].split('=')[1]
					setTimeout(() => {
						sessionStorage.removeItem('qiangform' + id || 'undefined')
						sessionStorage.removeItem('ddata' + id || 'undefined')
					}, 200)
				}
				if(path.indexOf('editgoods') > -1){
					let id = path.split('?')[1].split('&')[0].split('=')[1]
					setTimeout(() => {
						sessionStorage.removeItem('goodsform' + id || 'undefined')
					}, 200)
				}
				this.$store.commit('delpath', path)
			},
			tabclick(e) {
				this.$router.push(e.name)
			},

			// ==============================================
			// 🔥 总后台【退出登录】最终版
			// ==============================================
			async handleCommand(e) {
				if (e == 1) {
					this.$router.push('/shopcenter')
				} 
				else if (e == 2) {
					// 清除总后台所有存储（新 + 旧全部清干净）
					sessionStorage.removeItem('admin')
					sessionStorage.removeItem('admintoken')
					sessionStorage.removeItem('shopId')
					sessionStorage.removeItem('logo')
					sessionStorage.removeItem('putispermission')
					sessionStorage.removeItem('routeArr')
					
					// 清除总后台新KEY
					sessionStorage.removeItem('admin_main_token')
					sessionStorage.removeItem('admin_main_shopId')
					sessionStorage.removeItem('admin_main_logo')
					sessionStorage.removeItem('admin_main_admin')

					// 提示 + 跳转
					this.$message.success('已安全退出登录')
					setTimeout(() => {
						this.$router.replace('/')
					}, 300)
				}
				else if(e == 3){
					let res = await this.$api.balanceGet()
					this.num = res || 0
					this.tixianshow = true
				}
			},

			tixian(){
				if(this.num*1 < this.money*1){
					this.$message.error('提现金额不能大于余额')
				}else{
					this.$confirm('是否确认提现'+this.money+'元?', '提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						let res = await this.$api.balanceAdd({money:this.money})
						if(res){
							this.tixianshow = false
							this.money = 1
							this.$message.success('操作成功');
						}
					})
				}
			}
		},
		components: { theme }
	}
</script>

<style>
	.header .el-tabs__header {
		margin-bottom: 0;
	}
</style>
<style scoped>
	.header {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		height: 55px;
		background-color: #fff;
		width: 100%;
		justify-content: space-between;
	}
	.rig{display: flex;align-items: center;}
	.icon-box {
		width: 35px;
		height: 35px;
		display: flex;
		align-items: center;
		font-size: 20px;
		justify-content: center;
	}
</style>